let RENDERERS = {};
let DROP_HANDLERS = {};

function renderImage(layer, adunit) {
    
    let asset = adunit.assets[layer.assetId];
    let el = new Image();

    if(asset.src.startsWith("http")) {
        el.src = asset.src;
    }
    else {
        el.src = "https://storage.googleapis.com/assets-scenestealer-210713/" + asset.src;
    }
    
    if(!!layer.scaling) {
        switch(layer.scaling) {
        case "clip":
            break;
        case "fit":
            el.style.maxWidth = "100%";
            el.style.maxHeight = "100%";
            break;
        case "stretch":
        default:
            el.style.width = "100%";
            el.style.height = "100%";
        }
    }
    
    return el.outerHTML;
}

function renderVideo(layer, adunit) {

    let asset = adunit.assets[layer.assetId];
    let markup = "";

    let deferred = $.Deferred();

    //derive the parentId from the src as only parent's folder id is passed back
    let parentUrn = asset.src.split("/")[0];
    let thumbnailUrl = "https://storage.googleapis.com/assets-scenestealer-210713/" + asset.folderId + "/" + asset._id + "_thumb_00001.jpg";

    //look for a thumbnail and use that instead the of the actual video
    $.ajax({
        url: thumbnailUrl,
        method: "HEAD",
        async: true,
        success: function() {
            deferred.resolve("<img src='" + thumbnailUrl + "' style='width: 100%; height: 100%;' >")
        },
        error: function() {

            // fallback to the actual video
            markup = "<video paused muted>";
            if("undefined" !== typeof asset.encodings && asset.encodings != null && asset.encodings.length > 0) {
                $.each(asset.encodings, function(ix, enc) {
                    markup += "<source type='" + enc.contentType + "' src='" + "https://storage.googleapis.com/assets-scenestealer-210713" + enc.src + "' />";
                });
            }
            else {
                if(asset.src.startsWith("http")) {
                    markup += "<source type='" + asset.contentType + "' src='" + asset.src + "' />";
                }
                else {
                    markup += "<source type='" + asset.contentType + "' src='" + "https://storage.googleapis.com/assets-scenestealer-210713/" + asset.src + "' />";
                }        
            }
            markup += "</video>";

            if("undefined" == typeof layer.shouldTriggerThumbnailGeneration) {
                layer.shouldTriggerThumbnailGeneration = true;
            }

            deferred.resolve(markup);

        }
    });

    return deferred;

}

function renderText(layer) {
    return "<div class='text-div'>" + layer.src + "</div>";
}

function renderHtml(layer) {
    return layer.src;
}

RENDERERS["text/plain"] = renderText;
RENDERERS["text/html"] = renderHtml;

RENDERERS["image/jpg"] = renderImage;
RENDERERS["image/jpeg"] = renderImage;
RENDERERS["image/gif"] = renderImage;
RENDERERS["image/png"] = renderImage;
RENDERERS["image/svg+xml"] = renderImage;

RENDERERS["video/mp4"] = renderVideo;
RENDERERS["video/webm"] = renderVideo;
RENDERERS["video/quicktime"] = renderVideo;
RENDERERS["video/3gpp"] = renderVideo;
RENDERERS["video/x-msvideo"] = renderVideo;
RENDERERS["video/x-ms-wmv"] = renderVideo;

class BuilderService {
    
    constructor($q, $http, SERVICE_LOCATIONS, CONTENT_TYPE, FolderService, FOLDER_CONSTANTS) {
        
        this.$q = $q;
        this.$http = $http;
        this.SERVICE_LOCATIONS = SERVICE_LOCATIONS;
        this.CONTENT_TYPE = CONTENT_TYPE;
        this.FolderService = FolderService;
        this.FOLDER_CONSTANTS = FOLDER_CONSTANTS;

        this.fonts = {
            "Georgia": "Georgia, serif",
            "Palatino Linotype": "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
            "Times New Roman": "'Times New Roman', Times, serif",
            "Arial": "Arial, Helvetica, sans-serif",
            "Arial Black": "'Arial Black', Gadget, sans-serif",
            "Comic Sans MS": "'Comic Sans MS', cursive, sans-serif",
            "Impact": "Impact, Charcoal, sans-serif",
            "Lucida Sans Unicode": "'Lucida Sans Unicode', 'Lucida Grande', sans-serif",
            "Tahoma": "Tahoma, Geneva, sans-serif",
            "Trebuchet MS": "'Trebuchet MS', Helvetica, sans-serif",
            "Verdana": "Verdana, Geneva, sans-serif",
            "Courier New": "'Courier New', Courier, monospace",
            "Lucida Console": "'Lucida Console', Monaco, monospace"
        };

        this.widgets = {
            "Standard": {
                "x-reflow/canvas": {
                    "_id": "58820596c08f00b374fc80dd",
                    "contentType": "x-reflow/canvas",
                    "icon": "<i class='fa fa-object-group'></i>",
                    "name": "Canvas",
                    "width": 300,
                    "height": 250,
                    "src": '',
                    "contentEditable": false,
                    "backgroundColour": '#fff',
                    opacity: 1
              },
              "text/plain": {
                    "_id": "58820596c08f00b374fc80de",
                    "contentType": "text/plain",
                    "subType": "text",
                    "icon": "<i class='fa fa-font'></i>",
                    "name": "Static Text",
                    "width": 150,
                    "height": 50,
                    init: (layer) => {
                        layer.src = "Double click to enter text";
                        layer.autoFix = false;
                    }
              },
              "text/html": {
                    "_id": "58820596c08f00b374fc80df",
                    "contentType": "text/html",
                    "subType": "html",
                    "icon": "<i class='fa fa-code'></i>",
                    "name": "HTML Snippet",
                    "width": 150,
                    "height": 50,
                    init: (layer) => {
                        layer.src = "Double click to edit html";
                    }
                }
            },
            "Shapes": {
            },
            "Widgets": {                
            }
        };

        this.deferred = this.$q.defer();
        let widgetCount = 0;

        $(document).on("register-widget", (ev, widget) => {
            console.info("Registering: " + widget.name);
            if(!this.widgets[widget.widgetGroup]) {
                this.widgets[widget.widgetGroup] = {};
            }
            this.widgets[widget.widgetGroup][widget.contentType] = widget;
            widgetCount--;
            if(widgetCount == 0) {
                this.deferred.resolve(this.widgets);
            }
        });

        this.$http.get(this.SERVICE_LOCATIONS.CPM_API + "widget/list").then( (resp) => {
            $.each(resp.data, (ix, widget) => {
                console.log(widget.scriptPath);
                $.getScript(widget.scriptPath);
                widgetCount++;
            });
        });

    }
    
    getWidgets(cb) {
        this.deferred.promise.then( () => {
            cb(this.widgets);
        });        
    }

    findWidget(contentType) {
        var widget = null;
        $.each(this.widgets, (name, group) => {
            $.each(group, (t, w) => {
                if(t === contentType) {
                    widget = w;
                    return false;
                }
            });
            if(widget !== null) {
                return false;
            }
        });
        return widget;
    }

    getFonts() {
        return this.fonts;
    }
    
    getAdunit(id) {
        let deferred = this.$q.defer();
        deferred.resolve({
            "assets": [],
            "canvases": [
                {
                    id: ObjectId(),
                    name: "Home",
                    width: 300,
                    height: 250,
                    size: "300x250",
                    backgroundColour: "#FFFFFF",
                    expansionDirection: "auto",
                    verticalExpansionDirection: "down",
                    layers: [],
                    visibleInDesigner: true
                },
            ]
        });
        return deferred.promise;
    }
    
    saveAdunit(id, adunit) {
        let deferred = this.$q.defer();
        deferred.resolve();
        return deferred.promise;
    }

    getGoogleFonts() {
        let deferred = this.$q.defer(); 
        // TODO refactor this and make key configurable
        this.$http.get("https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyB1gE80KbH9frI6tt5-2cOWzJQnaasuy5A")
            .then(
                response => deferred.resolve(response),
                err => {
                    if (err.status === 401) {
                        $rootScope.$emit('accessDenied');
                    } else {
                        deferred.reject(err);
                    }
                }
            );

        return deferred.promise;
    }

    getReflowFonts() {
        let deferred = this.$q.defer();

        this.FolderService.searchOrFilterFolder(this.FOLDER_CONSTANTS.REFLOW_FONTS, "*", "*")
            .then((response) => {
                let assets = [];
                $.each(response.data.assets, (ix, asset) => {

                    if(asset.contentType == "application/font-woff") {
                        assets.push(asset);
                    }
                });

                deferred.resolve(assets);
                // $scope.assetsLoading = false;
            });

        return deferred.promise;

    }
}

angular.module('cpm').service('$builderService', ['$q', '$http', 'SERVICE_LOCATIONS', 'CONTENT_TYPE', 'FolderService', 'FOLDER_CONSTANTS', BuilderService]);

